import ClickOverlay from './clickOverlay'

export default ClickOverlay
